const PropTypes = require('prop-types');
const React = require('react');
const { actions: ShippingLabelActions } = require('../shipping_label_form_module');
const Details = require('../details');
const Order = require('../order');
const Package = require('../package');
const Shipment = require('../shipment');
const MultiOrderSelectContainer = require('./multi_order_select_container');
const MultiOrderCustomsContainer = require('./multi_order_customs_container');
const SubmitButtonContainer = require('./submit_button_container');

class DetailsContainer extends React.Component {
  componentDidMount() {
    ShippingLabelActions.setupPrimaryOrder(this.primaryOrder());
    ShippingLabelActions.setupShipment(this.shipment());
  }

  shipment() {
    return new Shipment(this.props.shipment);
  }

  package() {
    return new Package(this.props.package);
  }

  primaryOrder() {
    const parsedOrder = JSON.parse(this.props.primaryOrder);
    return new Order(parsedOrder);
  }

  render() {
    return (
      <div>
        <div className="module bd-rounded mb-2">
          <MultiOrderSelectContainer />
        </div>
        <Details
          package={this.package()}
        />
        <MultiOrderCustomsContainer
          errorMessage={this.props.customsErrorMessage}
        />
        <SubmitButtonContainer />
      </div>
    );
  }
}

DetailsContainer.propTypes = {
  primaryOrder: PropTypes.string.isRequired,
  package: PropTypes.object.isRequired,
  shipment: PropTypes.object.isRequired,
  customsErrorMessage: PropTypes.string,
};

module.exports = DetailsContainer;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/containers/details_container.jsx